

























































































import Vue from 'vue';

// DayJS
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import PickParentLeaguesModal from '@/components/NewManOfTheMatch/PickParentLeaguesModal.vue';
dayjs.extend(advancedFormat);

export default Vue.extend({
	name: '',

	props: {
		selectedManOfTheMatch: Object,
	},

	data: () => ({
		editManOfTheMatch: {
			id: '',
			name: '',
		},
	}),

	components: {
		PickParentLeaguesModal,
	},

	computed: {
		filteredManOfTheMatch() {
			const selectedManOfTheMatchLeagues: any[] = [];
			(this as any).selectedManOfTheMatch.join_league_manofthematch.map((m: any) => {
				if (m.leagueByLeague) selectedManOfTheMatchLeagues.push(m);
			});
			return selectedManOfTheMatchLeagues;
		},
	},

	methods: {
		GetIds(filteredManOfTheMatch: any[]) {
			const ids = filteredManOfTheMatch.map((val: { league: any }) => val.league);
			return ids;
		},
		handleClick(id: string) {
			this.$router.push({ name: 'league', params: { id } });
		},

		async saveDisplayName() {
			await this.$store.dispatch('updateManOfTheMatch', {
				id: this.editManOfTheMatch.id,
				name: this.editManOfTheMatch.name,
			});
			await this.$store.dispatch('getManOfTheMatches');
		},
	},

	filters: {
		day(val: number) {
			if (val === 1) return 'Monday';
			if (val === 2) return 'Tuesday';
			if (val === 3) return 'Wednesday';
			if (val === 4) return 'Thursday';
			if (val === 5) return 'Friday';
			if (val === 6) return 'Saturday';
			return 'Sunday';
		},

		dateToYear(val: string) {
			return dayjs(val).format('MMM YYYY');
		},

		shortenString(val: string) {
			return `${val.slice(0, 45)}...`;
		},
	},

	async mounted() {
		this.editManOfTheMatch.id = (this as any).selectedManOfTheMatch.id;
		this.editManOfTheMatch.name = (this as any).selectedManOfTheMatch.name;
	},
});
